import { CircularProgress, Paper, Theme } from '@mui/material';
import { api } from '@verifime/api-definition';
import { VerificationRequestedBy } from '@verifime/components';
import { useEffect, useState } from 'react';
import { TLogoResponse } from '../types';

export default function ClientLogoByOrganisationCode({
  organisationCode,
  title,
}: Readonly<{ organisationCode: string; title?: string }>) {
  const [logoResponse, setLogoResponse] = useState<TLogoResponse | null>(null);
  const [loading, setLoading] = useState(false);
  const [isError, setIsError] = useState(false);

  useEffect(() => {
    if (!organisationCode) {
      setLogoResponse(null);
      return;
    }
    setLoading(true);
    setIsError(false);
    api
      .getV1logoorganisationCodeOrganisationCode({
        params: { organisationCode },
      })
      .then(setLogoResponse)
      .catch(() => setIsError(true))
      .finally(() => setLoading(false));
  }, [organisationCode]);

  if (loading) {
    return (
      <Paper
        sx={(theme: Theme) => ({
          width: '100%',
          padding: theme.semantic.spacing.base,
          minHeight: theme.semantic.size['3xs'],
        })}
      >
        <CircularProgress />
      </Paper>
    );
  }

  if (!logoResponse || isError) {
    return;
  }

  return (
    <VerificationRequestedBy
      url={logoResponse.url}
      organisationName={logoResponse.organisationName}
      title={title}
    />
  );
}
